import { DocumentResource } from '@models/resources/document.model';

/**
 * 10 Demo-Dokumente quer durch alle Klassifizierungen. Ein Teil ist
 * für den Kunden sichtbar (`visible_to_customer: true`), einige nur
 * intern (werden später im Admin-Doku-Center gelistet, Sprint 3).
 */
export const DEMO_DOCUMENTS: DocumentResource[] = [
  {
    id: 1,
    name: 'Depoteröffnungsvertrag.pdf',
    classification: 'contract',
    issue_date: '2024-03-12',
    size_bytes: 284_312,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 2,
    name: 'Jahresbericht 2024.pdf',
    classification: 'report',
    issue_date: '2025-01-15',
    size_bytes: 1_842_004,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 3,
    name: 'Kaufbestätigung RE-2026-000097.pdf',
    classification: 'confirmation',
    issue_date: '2026-03-29',
    size_bytes: 162_880,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 4,
    name: 'Kaufbestätigung RE-2026-000094.pdf',
    classification: 'confirmation',
    issue_date: '2026-03-15',
    size_bytes: 158_210,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 5,
    name: 'Quartalsreport Q1 2026.pdf',
    classification: 'report',
    issue_date: '2026-04-04',
    size_bytes: 956_112,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 6,
    name: 'Reisepass-Kopie.pdf',
    classification: 'other',
    issue_date: '2024-03-10',
    size_bytes: 492_008,
    visible_to_customer: false,
    customer_id: 1,
  },
  {
    id: 7,
    name: 'KYC-Prüfprotokoll.pdf',
    classification: 'other',
    issue_date: '2024-03-11',
    size_bytes: 214_502,
    visible_to_customer: false,
    customer_id: 1,
  },
  {
    id: 8,
    name: 'AGB 2024.pdf',
    classification: 'contract',
    issue_date: '2024-01-01',
    size_bytes: 624_890,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 9,
    name: 'Halbjahresbericht 2025.pdf',
    classification: 'report',
    issue_date: '2025-07-02',
    size_bytes: 1_204_360,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 10,
    name: 'Steuerbescheinigung 2024.pdf',
    classification: 'other',
    issue_date: '2025-02-28',
    size_bytes: 398_554,
    visible_to_customer: true,
    customer_id: 1,
  },
  // --- Lagergebühr-Rechnungen (V3-Delta, Tag 4) ------------------------
  // Statt eigener /lagergebuehren-Ansicht landen die Lagergebühr-PDFs
  // als Dokumente in der Kundenliste und sind über den Klassifizierungs-
  // Filter eingrenzbar. Siehe Technisches Konzept §7.4 + ADR-003.
  {
    id: 11,
    name: 'Lagergebühr RE-2026-010045 H1.pdf',
    classification: 'storage_fee_invoice',
    issue_date: '2026-07-01',
    size_bytes: 148_220,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 12,
    name: 'Lagergebühr RE-2025-010038 H2.pdf',
    classification: 'storage_fee_invoice',
    issue_date: '2026-01-02',
    size_bytes: 146_040,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 13,
    name: 'Lagergebühr RE-2025-010022 H1.pdf',
    classification: 'storage_fee_invoice',
    issue_date: '2025-07-01',
    size_bytes: 145_120,
    visible_to_customer: true,
    customer_id: 1,
  },
  {
    id: 14,
    name: 'Lagergebühr RE-2024-010017 Jahresabrechnung.pdf',
    classification: 'storage_fee_invoice',
    issue_date: '2025-01-02',
    size_bytes: 156_780,
    visible_to_customer: true,
    customer_id: 1,
  },

  // --- Dokumente übriger Kunden (Sprint 3 Tag 4) ----------------------
  // Damit das Admin-Dokumenten-Center auch Treffer für Kunden 2-6 zeigt.
  {
    id: 15,
    name: 'Depoteröffnungsvertrag_Weinberger.pdf',
    classification: 'contract',
    issue_date: '2023-06-21',
    size_bytes: 302_114,
    visible_to_customer: true,
    customer_id: 2,
  },
  {
    id: 16,
    name: 'KYC-Protokoll Weinberger.pdf',
    classification: 'other',
    issue_date: '2023-06-22',
    size_bytes: 218_540,
    visible_to_customer: false,
    customer_id: 2,
  },
  {
    id: 17,
    name: 'Kaufbestätigung RE-2026-000078.pdf',
    classification: 'confirmation',
    issue_date: '2026-03-06',
    size_bytes: 166_320,
    visible_to_customer: true,
    customer_id: 2,
  },
  {
    id: 18,
    name: 'Depotvertrag Gasteiger.pdf',
    classification: 'contract',
    issue_date: '2024-09-04',
    size_bytes: 289_015,
    visible_to_customer: true,
    customer_id: 3,
  },
  {
    id: 19,
    name: 'Vollmacht Klug.pdf',
    classification: 'contract',
    issue_date: '2022-11-02',
    size_bytes: 214_090,
    visible_to_customer: true,
    customer_id: 4,
  },
  {
    id: 20,
    name: 'Reisepass-Kopie Klug.pdf',
    classification: 'other',
    issue_date: '2022-10-30',
    size_bytes: 510_882,
    visible_to_customer: false,
    customer_id: 4,
  },
  {
    id: 21,
    name: 'Erstkauf-Bestätigung Berger.pdf',
    classification: 'confirmation',
    issue_date: '2025-11-30',
    size_bytes: 148_640,
    visible_to_customer: true,
    customer_id: 5,
  },
  {
    id: 22,
    name: 'Depotkündigung Mayrhofer.pdf',
    classification: 'other',
    issue_date: '2026-02-15',
    size_bytes: 124_908,
    visible_to_customer: true,
    customer_id: 6,
  },
];
